<template>
  <div class="programs_table">
    <!-- <pulse-loader-component :loading="true"></pulse-loader-component> -->
    <beat-loader-component
      v-if="isLoading"
      :isLoading="isLoading"
    ></beat-loader-component>

    <div class="" v-else>
      <div class="d-flex flex-wrap gap-2 align-items-center justify-content-between mt-2">
        <div class="flex-grow-1" style="min-width: 260px;">
          <b-form-input
            v-model="search"
            class="field-container"
            placeholder="Search permissions..."
          />
        </div>
        <div class="d-flex gap-2">
          <b-button class="akkurate-gray-btn text-white" @click="expandAll">
            Expand all
          </b-button>
          <b-button class="akkurate-gray-btn text-white" @click="collapseAll">
            Collapse all
          </b-button>
        </div>
      </div>

      <div class="mt-3">
        <div
          v-for="(mod, index) in filteredModules"
          :key="moduleKey(mod) || index"
          class="border rounded mb-2"
        >
          <div class="d-flex align-items-center justify-content-between px-3 py-2 bg-light">
            <div class="fw-bold">{{ moduleTitle(mod) }}</div>
            <div class="d-flex gap-2">
              <b-button class="akkurate-gray-btn text-white" @click="selectAll(mod)">
                Select all
              </b-button>
              <b-button class="akkurate-gray-btn text-white" @click="deselectAll(mod)">
                Deselect all
              </b-button>
              <b-button class="akkurate-green-btn text-white" @click="toggleModule(mod)">
                {{ isCollapsed(mod) ? "Expand" : "Collapse" }}
              </b-button>
            </div>
          </div>

          <div v-show="!isCollapsed(mod)" class="px-3 py-2">
            <div
              v-for="(apermission, apermission_index) in mod.permissions"
              :key="(apermission && apermission.id) || apermission_index"
              class="d-flex align-items-start gap-2 py-2 border-bottom"
            >
              <b-form-checkbox
                class="mt-1"
                :checked="isSelected(apermission)"
                @change="onToggle(apermission, $event)"
              />
              <div class="flex-grow-1">
                <div class="fw-semibold d-flex flex-wrap align-items-center gap-2">
                  <span v-html="apermission.display_name || apermission.name"></span>
                </div>
                <div v-if="permissionDescriptionTooltip(apermission)" class="small text-muted">
                  {{ permissionDescriptionTooltip(apermission) }}
                </div>
                <div v-if="apermission?.name" class="small text-muted" style="font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;">
                  {{ apermission.name }}
                </div>
              </div>
            </div>
            <div v-if="!mod.permissions || mod.permissions.length === 0" class="text-muted small py-2">
              No permissions in this module.
            </div>
          </div>
        </div>
      </div>

      <div class="display_flex flex_end">
        <div>
          <button
            :disabled="!form.selected_role || is_Updating"
            @click="$emit('updatePermissionsNow')"
            class="btn text-white akkurate-green-btn"
          >
          <font-awesome-icon class="me-2" :icon="['fas', 'save']" />Save Changes
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";

export default {
  components: {
    BeatLoaderComponent,
  },
  props: ["users", "form", "permissions", "selectedPermissionIds", "is_Updating", "isLoading"],
  data() {
    return {
      selected: "first",
      search: "",
      collapsed: {},
    };
  },
  mounted() {
    // this.$Progress.start();
  },
  methods: {
    isSelected(p) {
      const id = Number(p?.id);
      if (!Number.isFinite(id)) return false;
      const list = Array.isArray(this.selectedPermissionIds) ? this.selectedPermissionIds : [];
      return list.includes(id);
    },
    onToggle(p, checked) {
      const id = Number(p?.id);
      if (!Number.isFinite(id)) return;
      this.$emit("togglePermission", { id, checked: !!checked });
    },
    selectAll(mod) {
      const ids = (Array.isArray(mod?.permissions) ? mod.permissions : [])
        .map((p) => p?.id)
        .filter((id) => id != null);
      this.$emit("selectModule", { ids, checked: true });
    },
    deselectAll(mod) {
      const ids = (Array.isArray(mod?.permissions) ? mod.permissions : [])
        .map((p) => p?.id)
        .filter((id) => id != null);
      this.$emit("selectModule", { ids, checked: false });
    },
    moduleKey(mod) {
      // Stable identifier must be module_name (not module_id).
      return String(mod?.module_name || "");
    },
    moduleTitle(mod) {
      const t = String(mod?.module_display_name || "").trim();
      return t || String(mod?.module_name || "").trim();
    },
    isCollapsed(mod) {
      const k = this.moduleKey(mod);
      return !!this.collapsed[k];
    },
    toggleModule(mod) {
      const k = this.moduleKey(mod);
      this.$set(this.collapsed, k, !this.collapsed[k]);
    },
    expandAll() {
      const next = {};
      (this.filteredModules || []).forEach((m) => {
        next[this.moduleKey(m)] = false;
      });
      this.collapsed = next;
    },
    collapseAll() {
      const next = {};
      (this.filteredModules || []).forEach((m) => {
        next[this.moduleKey(m)] = true;
      });
      this.collapsed = next;
    },
    /**
     * Plain text for tooltip from optional API `description` (strip markup, trim).
     * Returns null when no supplementary copy — label-only, no tooltip.
     */
    permissionDescriptionTooltip(apermission) {
      const raw = apermission?.description;
      if (raw == null) return null;
      const s = String(raw).trim();
      if (!s) return null;
      const plain = this.plainTextFromMaybeHtml(s);
      return plain || null;
    },
    plainTextFromMaybeHtml(s) {
      let t = String(s).replace(/<[^>]*>/g, " ");
      t = t
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&#39;/g, "'")
        .replace(/&apos;/g, "'")
        .replace(/&quot;/g, '"');
      return t.replace(/\s+/g, " ").trim();
    },
    checkboxClicked(apermission, module_id) {
      // console.log(apermission)
      // var module_  = this.permissions.find(one_module=> one_module.module_id == module_id)
      // if(module_)
      // {
      //     console.log(module_)
      //     // this.donors.splice(this.donors.indexOf(donorAlreadyAssigned), 1);
      //     // var permisn_ankasa = this.permissions[this.permissions.indexOf(module_)].permissions;
      //     // var found = permisn_ankasa.find(one_permi=>one_permi.id == apermission.id );
      //     // alert(permisn_ankasa.indexOf(permisn_ankasa).is_checked);
      // }
      // // console.log(apermission.is_checked);
      // this.$emit("permissionChecked",apermission.id,apermission.is_checked);
    },
  },
  computed: {
    filteredModules() {
      const q = String(this.search || "").trim().toLowerCase();
      const mods = Array.isArray(this.permissions) ? this.permissions : [];

      if (!q) {
        return mods
          .map((m) => {
            const list = Array.isArray(m?.permissions) ? m.permissions : [];
            if (list.length === 0) return null;
            return { ...m, permissions: list };
          })
          .filter(Boolean)
          .sort((a, b) => this.moduleTitle(a).localeCompare(this.moduleTitle(b)));
      }

      return mods
        .map((m) => {
          const list = Array.isArray(m?.permissions) ? m.permissions : [];
          const title = this.moduleTitle(m).toLowerCase();
          if (title.includes(q)) {
            if (list.length === 0) return null;
            return { ...m, permissions: list };
          }
          const nextPerms = list.filter((p) => {
            const dn = String(p?.display_name || "").toLowerCase();
            const n = String(p?.name || "").toLowerCase();
            const d = String(p?.description || "").toLowerCase();
            return dn.includes(q) || n.includes(q) || d.includes(q);
          });
          if (nextPerms.length === 0) return null;
          return { ...m, permissions: nextPerms };
        })
        .filter(Boolean)
        .sort((a, b) => this.moduleTitle(a).localeCompare(this.moduleTitle(b)));
    },
  },
};
</script>
